A short human-readable name of the workflow process.

This is required for a process history action of an uploaded candidate.
